import React from 'react';

import {
  useEditOrderModalQuery,
  useSaveOrderMutation
} from 'generated/graphql';

import * as types from './types';



export interface IData {
  formState: types.IFormState;
}

export function useQuery(orderId: string) {
  const tuple = useEditOrderModalQuery({
    variables: {
      orderId
    }
  });

  return React.useMemo(
    () => {
      const data: IData = {
        formState: {
          billingAddress: {
            addressee: tuple.data?.order?.billingAddress.addressee || '',
            street1: tuple.data?.order?.billingAddress.street1 || '',
            street2: tuple.data?.order?.billingAddress.street2 || '',
            city: tuple.data?.order?.billingAddress.city || '',
            usState: tuple.data?.order?.billingAddress.usState || '',
            postalCode: tuple.data?.order?.billingAddress.postalCode || '',
            countryCode: tuple.data?.order?.billingAddress.countryCode || '',
            company: tuple.data?.order?.billingAddress.company || '',
            phone: tuple.data?.order?.billingAddress.phone || ''
          },
          shippingAddress: {
            addressee: tuple.data?.order?.shippingAddress.addressee || '',
            street1: tuple.data?.order?.shippingAddress.street1 || '',
            street2: tuple.data?.order?.shippingAddress.street2 || '',
            city: tuple.data?.order?.shippingAddress.city || '',
            usState: tuple.data?.order?.shippingAddress.usState || '',
            postalCode: tuple.data?.order?.shippingAddress.postalCode || '',
            countryCode: tuple.data?.order?.shippingAddress.countryCode || '',
            company: tuple.data?.order?.shippingAddress.company || '',
            phone: tuple.data?.order?.shippingAddress.phone || ''
          }
        }
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}



export function useSaveOrder(orderId: string) {
  const [fnMutate, tuple] = useSaveOrderMutation({
    refetchQueries: []
  });

  const fnWrappedMutate = React.useCallback(
    async (formState: types.IFormState) => {
      await fnMutate({
        variables: {
          input: {
            id: orderId,
            billingAddress: {
              addressee: formState.billingAddress.addressee,
              street1: formState.billingAddress.street1,
              street2: formState.billingAddress.street2,
              city: formState.billingAddress.city,
              usState: formState.billingAddress.usState,
              postalCode: formState.billingAddress.postalCode,
              countryCode: formState.billingAddress.countryCode,
              company: formState.billingAddress.company,
              phone: formState.billingAddress.phone
            },
            shippingAddress: {
              addressee: formState.shippingAddress.addressee,
              street1: formState.shippingAddress.street1,
              street2: formState.shippingAddress.street2,
              city: formState.shippingAddress.city,
              usState: formState.shippingAddress.usState,
              postalCode: formState.shippingAddress.postalCode,
              countryCode: formState.shippingAddress.countryCode,
              company: formState.shippingAddress.company,
              phone: formState.shippingAddress.phone
            }
          }
        }
      });
    },
    [
      fnMutate,
      orderId
    ]
  );

  return React.useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}
